import React, { PureComponent } from 'react'

class Sticky extends PureComponent {
  state = {
    position: 'static',
    initialTopOffset: 0,
  }
  getDocumentHeight = () => {
    const body = document.body
    const html = document.documentElement
    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    )
    return height
  }
  handleScroll = event => {
    if (!this.wrapRef) return
    const currentTopDiff = this.wrapRef.getBoundingClientRect().top
    const scrollTop = Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    )
    this.setState(({ topOffset, position }) => {
      return {
        topOffset: this.state.initialTopOffset,
        prevDocumentHeight: this.getDocumentHeight(),
        position:
          scrollTop <= topOffset
            ? 'static'
            : currentTopDiff < 1
            ? 'fixed'
            : position,
      }
    })
  }
  handleResize = event => {
    if (!this.wrapRef) return
    this.setState(({ topOffset }) => {
      return {
        topOffset: this.state.initialTopOffset,
      }
    })
  }
  componentDidMount = () => {
    const initialTopOffset = this.wrapRef.getBoundingClientRect().top
    this.setState({
      prevDocumentHeight: this.getDocumentHeight(),
      initialTopOffset,
    })
    document.addEventListener('scroll', this.handleScroll, false)
    window.addEventListener('heightResize', this.handleResize, false)
  }
  componentWillUnmount = () => {
    document.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('heightResize', this.handleResize)
  }
  setWrapRef = element => (this.wrapRef = element)
  get wrapClass() {
    return this.state.position === 'fixed' ? this.props.className : ''
  }
  render = () => (
    <div ref={this.setWrapRef} style={{ width: '100%' }}>
      <div className={this.wrapClass}>{this.props.children}</div>
    </div>
  )
}

export default Sticky
